<template>
  <div class="saved-lists">
    <saved-lists-filter-bar
      :filters="filters"
      @on-handle-filters="onHandleFilters"
    ></saved-lists-filter-bar>
    <div class="saved-lists__content">
      <saved-lists-table
        :rows="rows"
        :loading="loading"
        :handle-delete-list-configuration="handleDeleteListConfiguration"
        :refresh-table="fetchLists"
      ></saved-lists-table>
      <div v-if="rows.length" class="saved-lists__pagination">
        <mi-pagination
          :model-value="pagination.currentPage"
          :max="pagination.totalPages"
          :max-pages="pagination.maxNavPage"
          size="14px"
          boundary-links
          direction-links
          boundary-numbers
          ellipses
          @update:model-value="handlePaginationChange"
        ></mi-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, reactive, watch, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import SavedListsFilterBar from '@/components/pac/saved-lists/SavedListFilterBar.vue'
  import SavedListsTable from '@/components/pac/saved-lists/SavedListsTable.vue'
  import { usePagination } from '@/composables/usePagination'
  import { deleteConfigurationList, getConfigurationLists } from '@/api'

  export default {
    name: 'SavedLists',
    components: {
      SavedListsFilterBar,
      SavedListsTable
    },
    setup() {
      const store = useStore()
      const rows = ref([])
      const loading = ref(false)
      const filters = reactive({
        mineOnly: false,
        todaysFilter: false,
        searchField: ''
      })
      const { pagination, handleChange: handlePaginationChange } = usePagination({ pageSize: 12 })
      const buildUrlSearchParams = () => {
        const params = {
          page: pagination.currentPage - 1,
          size: pagination.pageSize,
          sortBy: 'modifiedDate',
          sortDirection: 'DESC'
        }

        if (filters.searchField) {
          params.search = filters.searchField
        }

        if (filters.mineOnly) {
          params.creator = store.state.user.username
        }

        if (filters.todaysFilter) {
          const [date] = new Date().toISOString().split('T')
          params.createdDateFrom = date
          params.createdDateTo = date
        }

        return params
      }
      const fetchLists = async () => {
        loading.value = true
        try {
          const params = buildUrlSearchParams()
          const response = await getConfigurationLists(params)
          rows.value = response.elements || []
          pagination.totalPages = response.totalPages || 1
          pagination.totalElements = response.totalElements || 0
        }
        catch (error) {
          console.error('Error fetching lists:', error)
          rows.value = []
        }
        finally {
          loading.value = false
        }
      }

      const onHandleFilters = (key, value) => {
        if (key) {
          // eslint-disable-next-line security/detect-object-injection
          filters[key] = value
          pagination.currentPage > 1 ? pagination.currentPage = 1 : fetchLists()
        }
        else {
          fetchLists()
        }
      }

      const handleDeleteListConfiguration = async (id, handleCloseDeleteModal) => {
        await deleteConfigurationList(id)
        await fetchLists()
        handleCloseDeleteModal()
      }

      watch(() => pagination.currentPage, () => {
        fetchLists()
      })

      onMounted(() => {
        fetchLists()
      })

      return {
        rows,
        loading,
        filters,
        pagination,
        onHandleFilters,
        handlePaginationChange,
        buildUrlSearchParams,
        handleDeleteListConfiguration,
        fetchLists
      }
    }
  }
</script>

<style lang="scss" scoped>
  .saved-lists {
    &__content {
      padding: 24px;
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    &__pagination {
      display: flex;
      justify-content: center;
    }
  }
</style>
